<template>
  <v-expansion-panel
    :class="{
      'ca-panel--edit': editando,
      'ca-panel--disabled': deshabilitado,
      'ca-panel--error': error,
      'ca-panel--warning': warning && !error,
      'ca-panel--destacado': destacado,
      'ca-panel--dark': dark,
      'ca-panel--error-abierto': error_panel_abierto,
      'ca-panel--warning-abierto': warning_panel_abierto
    }"
    class="ca-panel"
    :lazy="lazy"
  >
    <v-expansion-panel-header>
      <template v-if="!editando">
        <div class="ca-panel-indexlabel" v-if="!editable && index_label">{{iconoLetra}}</div>
        <v-btn
          @click.stop="editar()"
          class="ca-panel-iconEditar"
          small
          v-if="editable && !deshabilitado"
        >
          <v-icon>edit</v-icon>
        </v-btn>
        <div class="ca-panel-titulo">
          {{titulo}}
          <i class="ca-panel-aclaracion" v-if="titulo_aclaracion">({{titulo_aclaracion}})</i>
        </div>
      </template>
      <template v-else>
        <v-icon @click.stop="cancelarEdicion()" class="ca-panel-iconCancelar">close</v-icon>
        <v-text-field
          @click.stop
          @keyup.enter="guardarEdicion()"
          @keyup.esc="cancelarEdicion()"
          class="ca-panel-input"
          counter="50"
          ref="input"
          v-model="titulo_edicion"
        ></v-text-field>
        <v-btn @click.stop="guardarEdicion()" class="ca-panel-buttonGuardar" small>
          <v-icon>check</v-icon>
        </v-btn>
      </template>
      <v-spacer></v-spacer>
      <div class="ca-panel-headerSlot">
        <template v-if="warning_cambios_sin_guardar">
          <v-alert class="ca-panel-alertCambios" icon="report" type="warning">
            Hay cambios sin guardar
          </v-alert>
        </template>
        <slot name="header" v-else></slot>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <slot name="pre-contenido"></slot>
      <div class="ca-panel-contenido">
        <slot name="contenido"></slot>
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
/**
   CAPanel perteneciente a un CAExpansionPanels (entre ambos componentes se wrappea VExpansionPanels),
   Uso:
   <ca-expansion-panels>
   <ca-panel>...</ca-panel>
   <ca-panel>...</ca-panel>
   <ca-panel>...</ca-panel>
   </ca-expansion-panels>
   */
export default {
  props: {
    titulo: {type: String, default: ''}, //Titulo del panel
    titulo_aclaracion: {type: String, default: ''}, //String adicional que va en itálica pegado al título
    editable: {type: Boolean, default: false}, //Si se setea, se agrega icono para editar al lado del título y se transforma en input.
    deshabilitado: {type: Boolean, default: false}, //Se grisa el título al no estar activo
    error: {type: Boolean, default: false}, //Panel en estado de error
    warning: {type: Boolean, default: false}, //Panel en estado de warning
    destacado: {type: Boolean, default: false}, //Se destaca el panel poniendo el header en itálica y bold.
    index: {type: Number, default: 1},
    index_label: {type: Boolean, default: false},
    dark: {type: Boolean, default: false},
    error_panel_abierto: {type: Boolean, default: false}, // Estilizar header como error con panel abierto y estado error
    warning_panel_abierto: {type: Boolean, default: false}, // Estilizar header como warning con panel abierto y estado warning
    warning_cambios_sin_guardar: {type: Boolean, default: false}, // Alerta de cambios sin guardar en header
    lazy: {type: Boolean, default: true}
  },
  data() {
    return {
      editando: false,
      titulo_edicion: ''
    };
  },
  computed: {
    iconoLetra() {
      if (!isNaN(this.index)) {
        this.index = this.index % 27;
        return String.fromCharCode(65 + this.index);
      }
    }
  },
  methods: {
    editar() {
      this.titulo_edicion = this.titulo;
      this.editando = true;
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },
    cancelarEdicion() {
      this.editando = false;
    },
    guardarEdicion() {
      this.$emit('update:titulo', this.titulo_edicion);
      this.$emit('cambio:titulo', true);
      this.editando = false;
    }
  }
};
</script>
<style lang="scss">
  .ca-panel {
    margin: 5px 0;
    background-color: color(gris-claro) !important;
    border-width: 0 !important;
    color: color(dark);
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12),
    0 1px 1px 0 rgba(0, 0, 0, 0.14);

    &.v-expansion-panel::before {
      box-shadow: none;
    }
    .v-expansion-panel-header {
      height: 54px;
      font-weight: 500;
      font-size: 18px;
      padding: 0 24px;
      &:before {
        background-color: unset; //Comportamiento no deseado (Cambia el color del header)
      }
    }
    .v-expansion-panel-header__icon .v-icon {
      color: color(dark) !important;
    }
    .v-expansion-panel-content__wrap {
      padding: 0;
    }
    .ca-panel-titulo {
      color: color(dark);
    }
    .ca-panel-aclaracion {
      margin-left: 5px;
    }
    .ca-panel-iconEditar.v-btn:not(.v-btn--round).v-size--small { // Necesario para sobre-escribir estilos de vuetify
      padding: 0 16px;
      min-width: unset;
      flex: unset !important;
      background-color: color(celeste-claro) !important;
      width: 24px;
      //height: 24px;
      margin: 0 10px 0 0;
      box-shadow: unset !important;
      &:hover {
        opacity: 0.4; //Hover effect aumentado
      }
      .v-icon {
        font-size: 20px;
      }
    }
    .ca-panel-iconCancelar {
      width: 24px;
      margin: 0 10px 0 0;
      color: color(dark);
    }
    .ca-panel-buttonGuardar {
      height: 32px;
      margin-top: 0;
      margin-bottom: 0;
      font-size: 13px;
      min-width: unset;
    }
    .ca-panel-input {
      padding-top: 0;
      margin-top: 10px;
      width: 440px;
      .v-input__slot {
        margin-bottom: 0 !important;
      }
      .v-counter {
        font-size: 10px;
        padding-top: 2px;
      }
    }
    .ca-panel-indexlabel {
      color: color(blanco);
      background-color: color(dark);
      align-self: center;
      font-weight: bold;
      font-size: 13px;
      margin-right: 25px;
      width: 30px;
      height: 30px;
      flex-grow: 0;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .spacer {
      flex-grow: 100 !important;
    }

    .ca-panel-alertCambios {
      background-color: color(mango);
      border: 0;
      color: color(texto-oscuro);
      font-size: 13px;
      border-radius: 18px;
      padding: 4px 10px;
      margin-right: 15px;
      .v-icon {
        color: color(texto-oscuro) !important;
        margin-right: 4px;
      }
    }

    &.v-expansion-panel--active {
      //Mismo nivel que clase ca-panel
      margin: 15px 0;
      transition: margin 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
      box-shadow: 0 3px 14px 2px rgba(0, 0, 0, 0.12),
      0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 5px 5px -3px rgba(0, 0, 0, 0.2);
      .v-expansion-panel-content {
        background-color: color(blanco);
      }
      .v-expansion-panel-header {
        transition: background-color 0.3s ease, color 0.3s ease;
        background-color: color(primary);
        color: color(blanco);
        border-top-left-radius: 2px;
        border-top-right-radius: 2px;
        min-height: unset;
      }
      .ca-panel-iconEditar.v-btn:not(.v-btn--round).v-size--small {
        background-color: color(blanco) !important;
        color: color(primary) !important;
      }
      .v-expansion-panel-header__icon .v-icon {
        color: color(blanco) !important;
      }
      .ca-panel-headerSlot {
        display: none; //Se oculta el slot del header al abrir el contenido, podria configurarse este comportamiento con un prop a futuro.
      }
      .v-expansion-panel-header .ca-panel-indexlabel {
        color: color(celeste);
        background-color: color(blanco);
      }

      .ca-panel-titulo {
        color: color(blanco);
      }
    }

    &:not(.ca-panel--error):not(.ca-panel--warning):not(.ca-panel--disabled):not(.v-expansion-panel--active) .v-expansion-panel-header:hover {
      background-color: color(fondo-claro);
      .ca-panel-titulo,
      .v-expansion-panel-header__icon .v-icon {
        color: color(celeste) !important;
      }
    }
  }

  //Modificadores, class seteada por attr :class en ca-panel para disabled y edit, para
  //active directamente se atrapa la clase de Vuetify.
  //Definiciones en orden de preponderancia, no alterar.
  .ca-panel--destacado {
    .v-expansion-panel-header {
      font-style: italic;
      color: color(primary);
    }
  }

  .ca-panel--disabled:not(.v-expansion-panel--active) {
    .ca-panel-titulo,
    .v-expansion-panel-header {
      background-color: color(fondo-deshabilitado);
      color: color(gris-deshabilitado);
    }
    .ca-panel-indexlabel {
      background-color: color(gris-deshabilitado);
    }
  }

  .ca-panel--dark.v-expansion-panel--active {
    .v-expansion-panel-header {
      background-color: color(gris);

      .ca-panel-titulo,
      .v-expansion-panel-header__icon .v-icon {
        color: color(blanco);
      }

      &:hover {
        background-color: color(gris-oscuro);

        .ca-panel-titulo {
          color: color(blanco);
        }
      }
    }
  }

  //agrego especifidad para cuando el error tenga mas relevancia que si esta o no abierto
  .ca-panel.ca-panel--error-abierto.ca-panel--error,
  .ca-panel--error {
    .ca-panel-titulo {
      color: color(blanco);
    }
    .v-expansion-panel-header {
      background-color: color(error);
      color: color(blanco);
    }
    .ca-panel-iconEditar {
      background-color: color(blanco) !important;
      color: color(error) !important;
    }
    .v-expansion-panel-header__icon .v-icon {
      color: color(blanco) !important;
    }
    .v-expansion-panel-header .ca-panel-indexlabel {
      color: color(error);
      background-color: color(blanco);
    }
  }

  .ca-panel.ca-panel--warning-abierto.ca-panel--warning,
  .ca-panel--warning {
    .ca-panel-titulo {
      color: color(dark);
    }
    .v-expansion-panel-header {
      background-color: color(warning);
      color: color(dark);
    }
    .ca-panel-iconEditar {
      background-color: color(dark) !important;
      color: color(warning) !important;
    }
    .v-expansion-panel-header__icon .v-icon {
      color: color(dark) !important;
    }
    .v-expansion-panel-header .ca-panel-indexlabel {
      color: color(warning);
      background-color: color(dark);
    }
  }

  .ca-panel--edit {
    .v-expansion-panel-header {
      background-color: color(blanco);
      color: color(dark);
      border-bottom: 1px solid color(celeste-claro);
    }
    .v-expansion-panel-header__icon .v-icon {
      color: color(dark) !important;
    }
    .ca-panel-iconCancelar:hover {
      color: color(rojo) !important;
    }
    &.v-expansion-panel--active .v-expansion-panel-header {
      // Si esta activo entonces el color va a ser gris
      background-color: color(gris-claro);
      border-color: color(gris-claro-secund);
    }
  }
</style>
